import script from "./ImportantDatesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportantDatesCard.vue?vue&type=script&setup=true&lang=ts"

import "./ImportantDatesCard.vue?vue&type=style&index=0&id=a021ffe6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a021ffe6"]])

export default __exports__